<template>
  <v-container fluid grid-list-xs>
    <loader :show="loader" :message="messageLoader"></loader>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1 mb-2>
        <span class="green--text">Cancha</span>
        <span class="ml-3 mr-3">></span>
        <span>Nueva Cancha</span>
      </v-flex>
      <v-flex xs12 md5 offset-md1>
        <h4 class="green--text headline">Nueva Cancha</h4>
      </v-flex>

      <v-flex xs12 md10 offset-md1>
        <v-card light>
          <v-card-text>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 md5>
                    <v-text-field
                      name="fieldName"
                      :label="currentField.name.length > 0 ? 'Nombre' : 'Este es el nombre de Cancha que verán los jugadores'"
                      light
                      v-model="currentField.name"
                      prepend-icon="star"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex x12>

                    <div class="green--text input-group input-group--prepend-icon theme--light input-group--text-field primary--text">
                      <div class="input-group__input">
                        <i aria-hidden="true" class="material-icons icon input-group__prepend-icon">
                          location_on
                        </i>
                        <gmap-autocomplete
                          v-model="currentField.address"
                          :defaultPlace="currentField.address"
                          @place_changed="setPlace"
                          @keyup="autocompleteOnChange($event)">
                        </gmap-autocomplete>
                      </div>
                      <div class="input-group__details">
                        <div class="input-group__messages">
                          <span class="error-message" v-if="showAutocompleteError">Este campo es requerido</span>
                        </div>
                      </div>
                    </div>
                  </v-flex>

                </v-layout>
                <v-layout row wrap>
                  <v-flex x12>
                    <gmap-map
                      :center="mapPos"
                      :zoom="15"
                      style="width: 100%; height: 300px">
                      <gmap-marker @dragend="dragEnd" :draggable="true" :position="mapPos">
                    </gmap-marker>
                  </gmap-map>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-on:click="goBack()" flat color="red">Cancelar</v-btn>
            <v-btn v-on:click="save()" color="green">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <br>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: "FieldForm",
  props: ['id'],
  data() {
    return {
      rules: {
          required: [
              val => {
                  let res = (String(val) || '').length > 0 || 'Este campo es obligatorio'
                  return res
              }
          ]
      },
      loader: false ,
      messageLoader: 'Cargando datos...',
      field: undefined,
      enabledSwitch: true,
      currentPlace: null,
      mapPos: {
        lat: 20.6944039,
        lng: -103.371338
      },
      editMode: false,
      showAutocompleteError: false
    }
  },
  created() {
    //do something after creating vue instance
    this.mapPos.lat = this.currentField.lat
    this.mapPos.lng = this.currentField.lng
    this.editMode = this.id ? true : false

    if(this.editMode) {
      this.loader = true

      this.loadField({
        id: this.id,
        callBack: (response) => {
          this.loader = false
        },
        errorCallback: () => {
          this.loader = false
        }
      })
    } else {
      this.setCurrentPosition()
    }
  },
  computed:{
    ...mapGetters([
      'currentField'
    ])
  },
  watch: {
    currentField(val) {
      this.mapPos = {
        lat: val.lat,
        lng: val.lng
      }
      console.log(this.mapPos)
    }
  },
  methods: {
    ...mapActions([
      'loadField',
      'createField',
      'updateField',
      'goBack'
    ]),
    dragEnd(event){
      let geocoder = new google.maps.Geocoder();
      let latlng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
      geocoder.geocode({
        "location": latlng
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if(results[0]) {
            this.setPlace(results[0])
          }
        } else {
          alert('Geocoder failed due to: ' + status);
        }
      });
    },
    setPlace(event){
      let cityStateCountry = Utils.parseGoogleDirections(event.address_components)
      this.currentField.city = cityStateCountry.city
      this.currentField.state = cityStateCountry.state
      this.currentField.country = cityStateCountry.country
      this.currentField.lat = event.geometry.location.lat()
      this.currentField.lng = event.geometry.location.lng()
      this.mapPos.lat = this.currentField.lat
      this.mapPos.lng = this.currentField.lng
      this.currentField.address = event.formatted_address
      this.currentPlace = event
    },
    setCurrentPosition() {
      if("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.mapPos.lat = position.coords.latitude
          this.mapPos.lng = position.coords.longitude
        });
      }
    },
    save(){
      if(this.editMode){
        this.messageLoader = 'Guardando cambios...'
        this.loader = true
        this.updateField(this.currentField)
      }else{
        this.showAutocompleteError = (this.currentField.lat === 0)
        if(!this.showAutocompleteError){
          this.messageLoader = 'Guardando...'
          this.loader = true
          this.createField(this.currentField)
        }
      }
    }
  }
}
</script>
<style lang="css" scoped>
  .error-message {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/fields/fieldForm.vue